module.exports = __webpack_public_path__ + "static/media/kishikawakatsumi.e50fb0aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kishikawakatsumi.png
// module id = 120
// module chunks = 0